import React from 'react';
import {Box} from "@mui/material";
import {CustomPagination} from "../../components/pagination";

export const CustomFooter = ({ columns, rows, pagination, targetField }) => {

    const total = rows.reduce((sum, row) => sum + Number(row[targetField]), 0).toFixed(2);

    return (
        <Box>
            <Box sx={{ display: 'flex', borderTop: '1px solid #ccc', backgroundColor: '#eee' }}>
                {columns.map((col) => (
                    <Box
                        key={col.field}
                        sx={{
                            flex: col.flex,
                            fontWeight: 'bold',
                        }}
                    >
                        {col.field === targetField ? `$ ${total}` : ''}
                    </Box>
                ))}
            </Box>
            <CustomPagination data={pagination.data} onChange={pagination.onChange}/>
        </Box>
    );
};